import { render, staticRenderFns } from "./RegionalChallengesPage.vue?vue&type=template&id=1f091b2d&scoped=true"
import script from "./RegionalChallengesPage.vue?vue&type=script&lang=js"
export * from "./RegionalChallengesPage.vue?vue&type=script&lang=js"
import style0 from "./RegionalChallengesPage.vue?vue&type=style&index=0&id=1f091b2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f091b2d",
  null
  
)

export default component.exports